import { render, staticRenderFns } from "./captains.vue?vue&type=template&id=3b9a68d0&scoped=true&"
import script from "./captains.vue?vue&type=script&lang=js&"
export * from "./captains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a68d0",
  null
  
)

export default component.exports